module.exports = __webpack_public_path__ + "static/Rochelle.30f94245.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mentImg/Rochelle.jpg
// module id = 246
// module chunks = 25111403944408 251948199435738